// extracted by mini-css-extract-plugin
export default {"Header":"HeaderV2_Header__iDVWf","SettingTitle":"HeaderV2_SettingTitle__VQzsN","saveLoading":"HeaderV2_saveLoading__5RCcr"};